import { ApolloLink } from '@apollo/client';
import { logErrorToSentry } from '@modules/common/utils';

// middleware to log request trace ID
export const errorLoggerMiddleware = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    const shouldLogErrors =
      process.env.REACT_APP_ENVIRONMENT === 'production' ||
      process.env.REACT_APP_ENVIRONMENT === 'preprod';

    if (!shouldLogErrors) {
      return response;
    }

    if (response.errors && response.errors.length > 0) {
      const {
        headers: requestHeaders,
        response: { headers: responseHeaders },
      } = operation.getContext();

      const failedRequestDetails = {
        operation: operation.operationName,
        slug: requestHeaders.slug,
        requestHeaders: JSON.stringify(requestHeaders),
        variables: JSON.stringify(operation.variables),
        traceID: responseHeaders?.get('x-entr-trace-id'),
        errors: JSON.stringify(response.errors),
      };

      logErrorToSentry(
        new Error(
          `${operation.operationName} operation failed: ${response.errors
            .map((error) => error.message)
            .join(', ')}`,
        ),
        {
          tags: {
            traceID: failedRequestDetails.traceID,
            slug: requestHeaders.slug,
          },
          extra: failedRequestDetails,
          fingerprint: [
            '{{ default }}',
            `${operation.operationName}_${new Date().toISOString()}`, // Unique fingerprint for each error, so we get separate alert for each error
          ],
        },
      );
    }

    return response;
  });
});
